import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Link} from "react-router-dom";
import ReactDOMServer from 'react-dom/server';
import {Tab, Tabs, TabList, TabPanel} from 'react-tabs';
import classnames from 'classnames';
import {Map} from "immutable";
import {Icon, ProgressBar} from "@blueprintjs/core";
import Modal from "@atlaskit/modal-dialog/dist/esm/components/Modal";

// Components
import IssueDetail from "./IssueDetail";
import IssueFiles from './IssueFiles';
import DeleteDialog from '../../../components/dialogs/DeleteDialog';
import IssuePrint from "../../../components/common/IssuePrint";

// Actions
import {
    getIssue,
    updateIssue,
    uploadIssueFiles,
    downloadIssueFile,
    deleteIssueFile,
    deleteIssue,
    cleanIssues
} from "../../../actions/issues";
import {addNotification} from "../../../actions/notifications";
import {downloadPdf} from "../../../actions/content";


class IssueTabs extends Component {
    constructor(props) {
        super(props);

        this.state = {
            tabIndex: this.getSelectedIndex(),
            editMode: false,
            canSubmit: false,
            status: '',
            // modal
            modalIsOpen: false,
            modalType: null
        };

        this.getSelectedIndex = this.getSelectedIndex.bind(this);
        this.handleTabChange = this.handleTabChange.bind(this);
    }
    componentDidMount() {
        this.props.getIssue(this.props.match.params.issueId);
    }
    componentWillUnmount() {
        this.props.cleanIssues();
    }

    // Tab handlers
    getSelectedIndex() {
        const {issueId} = this.props.match.params;

        // Check if any child route is active. As last step, check if principal route is active to assign default tab index.
        switch (this.props.history.location.pathname) {
            case '/ventas/albaranes/' + issueId + '/detalle':
                return 0;
            case '/ventas/albaranes/' + issueId + '/ficheros':
                return 1;
            default:
                return 0;
        }
    }
    handleTabChange(index, lastIndex, event) {
        const {issueId} = this.props.match.params;
        let route = '';

        switch (index) {
            case 0:
                route = '/ventas/albaranes/' + issueId + '/detalle';
                break;
            case 1:
                route = '/ventas/albaranes/' + issueId + '/ficheros';
                break;
            default:
                break;
        }

        this.props.history.push(route);
        this.setState({
            tabIndex: this.getSelectedIndex()
        });
    }

    // IssueDetail handlers
    handleEditClick = () => {
        this.setState({
            editMode: true
        });
    };
    handleCancelClick = () => {
        this.child.updateIssueState();
        this.setState({
            editMode: false,
            canSubmit: false
        });
    };
    handleSaveClick = () => {
        this.child.updateIssue();
        this.setState({
            editMode: false
        });
    };
    canSubmit = (canSubmit) => {
        this.setState({ canSubmit })
    };

    // Print PDF
    printPdf = () => {
        const htmlHeader = ReactDOMServer.renderToStaticMarkup(<div></div>);
        const generateStaticMarkup = ReactDOMServer.renderToStaticMarkup(
            <IssuePrint
                issue={this.props.issue}
            />
        );
        const htmlFooter = ReactDOMServer.renderToStaticMarkup(
            <div style={{
                width: '100%',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center'
            }}>
                <div style={{ alignSelf: 'flex-end', fontSize: 12, marginRight: '30px' }}>
                    - <span className="pageNumber"></span> -
                </div>
                <div style={{ fontSize: 6 }} >INSCRITA EN EL REGISTRO MERCANTIL DE MURCIA, TOMO MU-3142, FOLIO 112, HOJA MU-87833</div>
            </div>
        );

        this.props.downloadPdf(generateStaticMarkup, {
            title: this.props.issue.get('issue_code') + '.pdf',
            printBackground: true,
            displayHeaderFooter: true,
            headerTemplate: htmlHeader,
            footerTemplate: htmlFooter,
            margin: {
                top: '50px',
                right: '50px',
                left: '50px',
                bottom: '150px'
            }
        });
    };

    // Modal handlers
    openModal = (modalType) => {
        this.setState({
            modalType,
            modalIsOpen: true
        });
    };
    closeModal = () => {
        this.setState({
            modalType: null,
            modalIsOpen: false
        })
    };

    render() {
        const { tabIndex, editMode, canSubmit } = this.state;

        // Modal Area
        let modal = null;
        if (this.state.modalIsOpen) {
            switch (this.state.modalType) {
                case 'deleteDialog':
                    modal = {
                        width: 'medium',
                        title: 'Borrar albarán de venta',
                        body: (
                            <DeleteDialog
                                text={ this.props.issue.get('issue_code') }
                            />
                        ),
                        footer: (
                            <div className="modal-footer">
                                <button
                                    key="cancel"
                                    type="button"
                                    className="btn btn-cancel"
                                    label={'Cancelar'}
                                    style={{
                                        color: 'gray',
                                        marginRight: 15
                                    }}
                                    onClick={this.closeModal}
                                >
                                    {'Cancelar'}
                                </button>
                                <button
                                    key="delete"
                                    type="button"
                                    className="btn btn-danger"
                                    onClick={ () => {
                                        this.props.deleteIssue(this.props.issue.get('_id'));
                                        this.closeModal();
                                        this.props.history.push('/ventas/albaranes');
                                    }}
                                >
                                    {'Borrar'}
                                </button>
                            </div>
                        )
                    };
                    break;
                default:
                    modal = {
                        title: '',
                        body: null,
                        footer: null
                    };
                    break;
            }
        }

        return (

            <div id="page-wrapper" className="gray-bg">
                <div className="row wrapper border-bottom white-bg page-heading">
                    <div className="col d-flex align-items-center">
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item">
                                <Link to="/ventas/resumen">Ventas</Link>
                            </li>
                            <li className="breadcrumb-item">
                                <Link to="/ventas/albaranes">Albaranes</Link>
                            </li>
                            <li className="breadcrumb-item active">
                                <strong>{ this.props.issue.get('issue_code') }</strong>
                            </li>
                        </ol>
                    </div>
                    { this.props.uploadProgress.get('isUploading')
                        ? <div className="col d-flex align-items-center justify-content-end">
                            <ProgressBar
                                intent="PRIMARY"
                                value={ this.props.uploadProgress.get('percent') } />
                        </div>
                        : null
                    }
                    { tabIndex === 0
                        ? (
                            <div className="col d-flex align-items-center justify-content-end">
                                {!editMode
                                    ? <div className="title-action">
                                        <button
                                            className="btn btn-custom"
                                            onClick={ this.printPdf }
                                        ><Icon icon="print"/>Imprimir</button>
                                        { this.props.issue.get('can_delete')
                                                ? <button
                                                    className="btn btn-danger"
                                                    onClick={ () => this.openModal('deleteDialog') }
                                                >Borrar</button>
                                                : null
                                        }
                                        <button className="btn btn-custom" onClick={this.handleEditClick}>Editar</button>
                                    </div>
                                    : <div className="title-action">
                                        <button className="btn btn-cancel" onClick={this.handleCancelClick}>Cancelar</button>
                                        <button
                                            className="btn btn-primary"
                                            onClick={this.handleSaveClick}
                                            disabled={!canSubmit}
                                        >Guardar
                                        </button>
                                    </div>
                                }
                            </div>
                        ) : ''
                    }
                </div>
                <div className="wrapper wrapper-content">
                    <div className="row">
                        <div className="col">
                            <div className="tabs-container">
                                { this.props.issue.get('_id')
                                    ? (
                                <Tabs
                                    selectedIndex={tabIndex}
                                    onSelect={this.handleTabChange}
                                    selectedTabPanelClassName="active show"
                                >
                                    <TabList className="nav nav-tabs">
                                        <Tab>
                                            <Link to="#"
                                                  className={'nav-link ' + classnames({'active show': tabIndex === 0})}>Detalle</Link>
                                        </Tab>
                                        <Tab>
                                            <Link to="#"
                                                  className={'nav-link ' + classnames({'active show': tabIndex === 1})}>Ficheros</Link>
                                        </Tab>
                                    </TabList>
                                    <div className="tab-content">
                                        <TabPanel className="tab-pane">
                                            <IssueDetail
                                                onRef={ref => (this.child = ref)}
                                                editMode={this.state.editMode}
                                                canSubmit={this.canSubmit}
                                                issue={this.props.issue}
                                                updateIssue={this.props.updateIssue}
                                            />
                                        </TabPanel>
                                        <TabPanel className="tab-pane">
                                            <IssueFiles
                                                issue={this.props.issue}
                                                uploadIssueFiles={this.props.uploadIssueFiles}
                                                uploadProgress={this.props.uploadProgress}
                                                downloadIssueFile={this.props.downloadIssueFile}
                                                deleteIssueFile={this.props.deleteIssueFile}
                                                addNotification={this.props.addNotification}
                                            />
                                        </TabPanel>
                                    </div>
                                </Tabs>
                                        )
                                        : null
                                    }
                            </div>
                        </div>
                    </div>
                </div>
                { this.state.modalIsOpen && (
                    <Modal
                        width={modal.width}
                        heading={modal.title}
                        footer={() => modal.footer}
                        autoFocus={false}
                        onClose={this.closeModal}
                    >
                        {modal.body}
                    </Modal>
                )}
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    // Reducers
    const issueReducer = state.issues;

    // Issue
    let issue = issueReducer.get('payload') || Map({});

    if (!(issue instanceof Map)) {
        issue = Map({})
    }

    // Upload Progress
    const uploadProgress = Map({
        isUploading: issueReducer.get('isUploading') || false,
        percent: issueReducer.get('percent') || 0
    });

    return {
        issue,
        uploadProgress
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getIssue: (issueId) => dispatch(getIssue(issueId)),
        updateIssue: (issueId, issue) => dispatch(updateIssue(issueId, issue)),
        uploadIssueFiles: (issueId, files) => dispatch(uploadIssueFiles(issueId, files)),
        downloadIssueFile: (issueId, fileId) => dispatch(downloadIssueFile(issueId, fileId)),
        deleteIssueFile: (issueId, fileId) => dispatch(deleteIssueFile(issueId, fileId)),
        deleteIssue: (issueId) => dispatch(deleteIssue(issueId)),
        cleanIssues: () => dispatch(cleanIssues()),
        addNotification: (notification) => dispatch(addNotification(notification)),
        downloadPdf: (htmlString, pdfOptions) => dispatch(downloadPdf(htmlString, pdfOptions))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(IssueTabs);



// WEBPACK FOOTER //
// ./src/containers/sales/issues/IssueTabs.js